import React from 'react'
import Topbar from '../../Home/Mainhomeone/Topbar'
import Header from '../..//Globle/Header1'
import Navigation from '../../Home/Mainhomeone/Navigation'
import Footer1 from '../../Globle/Footer1'
import Breadcrumb from '../../Globle/Breadecrumb'
import BreadCrumbImage from '../Mainshop/BreadCrumbImage'
import Prodect from '../Mainshop/Prodect'

const Main = () => {
    return (
        <>
            <Topbar />
            <Header />
            <Navigation />
            <Breadcrumb title='Shop' />
            <BreadCrumbImage />
            <Prodect />
            <Footer1 />
        </>
    )
}

export default Main
